/*
  StyledHeader is a template component, extended by StyledLandingHeader and StyledLocationsHeader.
  The extensions configure StyledHeader with four local CSS variables: 
  --header-bg-color, --header-fg-color, --header-grid-flow-main, --title-size,
  and override styles with additional rules.
*/

import styled from "styled-components";
import { Breakpoints } from "../AppTheme";

export const StyledHeader = styled.header`
  width: 100%;
  box-sizing: border-box;

  display: grid;
  grid-template-rows: 1fr;
  grid-auto-rows: min-content;
  grid-auto-columns: 1fr auto; //brand, search (locs) -> 1col (landing)
  /* grid-auto-rows: 1fr min-content; //brand, search (landing) -> 1col (locs) */
  grid-auto-flow: var(--header-grid-flow-main);

  background-color: var(--header-bg-color);
`;

export const StyledBrandContainer = styled.div`
  justify-self: start;
  box-sizing: border-box;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 0.5rem;

  h1 {
    color: var(--header-fg-color);
    font-size: var(--title-size);
    font-weight: bolder;
    white-space: nowrap;
  }

  a {
    padding: 0.5rem;
    margin: -0.5rem;
    vertical-align: middle;
  }

  button {
    background-color: var(--header-bg-color);
    border: none;
  }

  img {
    height: var(--title-size);
    vertical-align: inherit;
    cursor: pointer;
  }
`;

export const StyledSearchContainer = styled.div`
  box-sizing: border-box;
  width: 100%;

  display: grid;
  grid-auto-flow: var(--header-grid-flow-main);
  align-content: center;

  background-color: var(--app-primary-color);

  @media ${Breakpoints.mobile} {
    justify-content: normal;
  }
`;

export const StyledSearchContainerTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a,
  a:hover,
  a:focus,
  a:active {
    color: #fff !important;
    white-space: nowrap;
  }
`;

export const StyledInfoLnk = styled.div`
  //box-model
  box-sizing: border-box;
  padding: var(--lib-default-spacing);

  align-items: center;
  display: flex;
  justify-content: center;
  justify-self: end;

  text-align: center;
  font-size: var(--lib-text-size-1);
  color: #DBDBDB;

   a {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

  a + a {
    border-left: 1px solid currentColor;
  }

  span {
    min-width: var(--lib-min-card-width);
    max-width: var(--lib-max-card-width);
  }

  @media ${Breakpoints.mobile} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;

    a {
      display: block;
      width: 100%;
      text-align: center;
    }

    a + a {
      border-left: none;
    }
  }
`;

export const StyledLandingHeader = styled(StyledHeader)`
  //Landing Variables passed down to children
  display: grid;
  grid-template-columns: 1fr 1fr;
  --header-bg-color: #F0EFF8;
  --header-fg-color: var(--app-primary-color);
  --header-grid-flow-main: row;
  --title-size: var(--lib-text-size-5);

  ${StyledBrandContainer} {
    padding: var(--lib-default-spacing);
    justify-content: center;
    justify-self: start;
  }

  ${StyledSearchContainer} {
    padding: var(--lib-default-spacing);
    justify-content: center;

    grid-template-columns: minmax(min-content, 25rem);

    h2 {
      width: 100%;
      margin-bottom: var(--lib-default-spacing);
      display: inline;
      font-size: var(--lib-text-size-3);
      text-align: start;
      text-transform: uppercase;
      color: var(--header-bg-color);
      justify-self: center;
    }
  }
  
  ${StyledInfoLnk} {
    color: #111C76;
    a:link {
      color: #111C76;
    }
    a:visited {
      color: #111C76;
    }
    a:hover {
      color #1A19BC;
    }
  }

    @media ${Breakpoints.mobile} {
      grid-template-columns: 1fr;
        ${StyledBrandContainer} {
          width: 100%;
        }
        ${StyledInfoLnk} {
          background-color: #111C76;
          width: 100%;
          color: #DBDBDB;
          a:link {
            color: #DBDBDB;
          }
          a:visited {
            color: #DBDBDB;
          }
          a:hover {
            color #FFFFFF;
          }
        }
    }
`;

export const StyledLocationsHeader = styled(StyledHeader)`
  //Locations Variables passed down to children
  --header-fg-color: var(--lib-foreground);
  --header-bg-color: var(--app-primary-color);
  --header-grid-flow-main: column;
  --title-size: var(--lib-text-size-4);

  padding: var(--lib-default-spacing);
  // Align perfectly with List
  padding-left: calc(var(--lib-default-spacing) + 3px);
  gap: var(--lib-default-spacing);
  justify-content: space-between;

  h2 {
    display: none;
  }

  ${StyledBrandContainer} {
    padding: 0rem;
    justify-content: start;
  }

  ${StyledSearchContainer} {
    padding: 0rem;
    justify-self: end;
    justify-content: end;

    grid-template-columns: minmax(min-content, 25rem);
  }

  ${StyledSearchContainerTop} {
    display: none;
  }
  
  ${StyledInfoLnk} {
    a:link {
      color: #DBDBDB;
    }
    a:visited {
      color: #DBDBDB;
    }
    a:hover {
      color #FFFFFF;
    }
  }

  @media ${Breakpoints.mobile} {
    
    grid-auto-flow: unset;
    ${StyledBrandContainer} {
      width: 100%;
      justify-content: center;
      img {
        height: var(--lib-text-size-4);
      }
    }

    ${StyledInfoLnk} {
      width: 100%;
      padding: 0;
    }
  }
`;
